module.exports = "<p>\r\n  forgot works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/PRO/Documents/GitHub/CGStore-Front/src/app/auth/forgot/forgot.component.html
// module id = ../../../../../src/app/auth/forgot/forgot.component.html
// module chunks = main